import React from "react";
import { Check, Video, Mic, Headphones, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPlan } from "../../../../slices/planSlice";
import logo from "../../../../assets/9.png";

export default function Membresia() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { podcast } = useSelector((state) => state.clientes);

  const handleNavigateToPay = (plan) => {
    dispatch(setPlan(plan));
    navigate("/client/pago");
  };

  const plans = [
    {
      title: "Plan Creador",
      price: "$9,500/mes",
      features: [
        "4 sesiones de 1 hora al mes",
        "Producción profesional (audio + video) 3 cámaras",
        "Edición básica (color y sonido)",
        "Acceso al estudio con previa reserva",
      ],
      icon: <Video size={24} className="text-blue-500" />,
      color: "blue",
    },
    {
      title: "Plan Pro",
      price: "$14,500/mes",
      features: [
        "8 sesiones de 1 hora al mes",
        "Edición avanzada (cortes, subtítulos, transiciones)",
        "4 reels optimizados para redes",
        "Prioridad en agenda",
      ],
      icon: <Mic size={24} className="text-green-500" />,
      color: "green",
    },
    {
      title: "Plan Elite",
      price: "$19,900/mes",
      features: [
        "12 sesiones de 1 hora al mes",
        "Producción multiángulo",
        "Edición premium (efectos, intros, animaciones)",
        "8 reels optimizados",
        "Asesoría en estrategia de contenido",
      ],
      icon: <Headphones size={24} className="text-purple-500" />,
      color: "purple",
    },
    {
      title: "Plan Corporativo",
      price: "Desde $29,900/mes",
      features: [
        "Producción a la medida",
        "Branding y estrategia audiovisual",
        "Asesoría en distribución y redes",
        "Equipo dedicado a la empresa",
      ],
      icon: <Star size={24} className="text-yellow-900" />,
      color: "yellow",
    },
  ];

  return (
    <div className="bg-background min-h-screen w-full px-4 sm:px-10 font-poppina">
      <div className="mt-2 text-gray-500 sm:text-base text-sm flex items-center">
        <p
          onClick={() => navigate("/client")}
          className="mr-4 text-subtitle sm:text-base text-sm hover:text-text cursor-pointer"
        >
          Cuenta
        </p>
        <p>{">"}</p>
        <p
          onClick={() => navigate(-1)}
          className="mx-4 cursor-pointer sm:text-base text-sm text-subtitle hover:text-text"
        >
          Podcast: {podcast.name}
        </p>
        <p>{">"}</p>
        <p className="mx-4 sm:text-base text-sm text-text">Membresias</p>
      </div>

      <div className="text-center mt-10 mb-10">
        <h1 className="text-xl sm:text-4xl font-bold text-gray-800 dark:text-white">
          Planes de Membresía
        </h1>
        <p className="text-gray-600 sm:text-base text-sm dark:text-gray-300 mt-2">
          Elige el plan que mejor se adapte a tus necesidades.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-4">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`bg-background w-full sm:w-[400px] h-auto shadow-xl rounded-2xl p-4 sm:p-6 transform transition-all hover:scale-105 border border-gray-100 dark:border-gray-700 flex flex-col`}
          >
            <div className="flex-1">
              <p
                className={`w-[180px] rounded-ss-lg rounded-ee-lg text-center absolute top-0 left-0 p-1 bg-${plan.color}-500 font-semibold text-white mb-10`}
              >
                {plan.price}
              </p>
              <div className="flex items-center mt-10 mb-6">
                <div
                  className={`p-2 bg-${plan.color}-500 dark:bg-${plan.color}-900 rounded-lg`}
                >
                  <img src={logo} className="w-10" alt="" />
                </div>
                <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 dark:text-white ml-4">
                  {plan.title}
                </h2>
              </div>

              <div className="mb-4">
                <h1 className="sm:text-2xl text-text font-bold">
                  {plan.price}
                </h1>
              </div>

              <ul className="space-y-3">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start">
                    <Check
                      size={16}
                      className={`text-${plan.color}-500 flex-shrink-0 mt-1`}
                    />
                    <span className="text-gray-700 dark:text-gray-300 ml-2">
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <button
              onClick={() => handleNavigateToPay(plan)}
              className={`mt-6 bg-${plan.color}-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-xl w-full font-semibold hover:bg-${plan.color}-600 transition-colors`}
            >
              Obtener {plan.title}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
